<div class="aab">
  <ng-content select="[askBarTop]"></ng-content>
  <div class="aab-head">
    <strong>
      <span class="aab-star">✦</span>
      Ask {{ agentName }}
      <span class="aab-tagline">· Your intelligent fan concierge</span>
    </strong>
    <small *ngIf="context">Context: {{ context }}</small>
  </div>
  <div class="aab-chips">
    <button type="button" *ngFor="let chip of chips" class="aab-chip" (click)="chipSelected.emit(chip.message)">{{ chip.label }}</button>
  </div>
  <ng-content></ng-content>
</div>
